module.exports = __webpack_public_path__ + "static/media/icon-status2.d28427e8.svg";